import type { BootSnapshot } from './boot-readiness';

/** Display is released by completed work, never elapsed presentation time.
 * Native health is acknowledged separately by the committed game interface. */
export function canPresentStartupContent(progress: BootSnapshot): boolean {
  return progress.ready && !progress.failed?.length && progress.total > 0 && progress.settled.length === progress.total;
}
